import { render, staticRenderFns } from "./inmueble-data.vue?vue&type=template&id=54ebc98e&scoped=true&"
import script from "./inmueble-data.vue?vue&type=script&lang=js&"
export * from "./inmueble-data.vue?vue&type=script&lang=js&"
import style0 from "./inmueble-data.vue?vue&type=style&index=0&id=54ebc98e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ebc98e",
  null
  
)

export default component.exports